import { AxiosPromise } from 'axios';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import TypeDestinationForm from 'system/components/type-destination/form';
import { typeDestinationCrumbs } from '../constants';
import { transformRequestTypeDestination } from '../utils/transformer-type-destination-request';

const TypeDestinationNewPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/sistema/eventmanager/tipidestinazione');
  };

  const insertTypeDestination = useHttpClient(`${__OPERATION__EVENT__ADMIN__}/tipoDestinazione`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback((formValues) => {
    const data = transformRequestTypeDestination(formValues);
    (
      insertTypeDestination({
        data,
      }) as AxiosPromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/eventmanager/tipidestinazione');
    });
  }, []);
  return (
    <>
      <Breadcrumbs items={[...typeDestinationCrumbs, { name: 'Nuovo Tipo/Destinazione' }]} />
      <TypeDestinationForm
        onCancel={onCancel}
        title="Aggiungi nuovo tipo destinazione"
        onOk={onSubmit}
      />
    </>
  );
};

TypeDestinationNewPage.displayName = 'New destination page component';

export default TypeDestinationNewPage;
